import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import config from "../../config";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { Table, Button, Modal, Input, Tooltip, Space } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import SelectUsersExcelButton from "./SelectUsersExcelButton";


const AddCourse = () => {
    const [formData, setFormData] = useState({
        title: "",
        shortDescription: "",
        description: "",
        price: 0,
        tags: [],
        enrolledUserIds: [],
        videos: [],
        pictureUrl: "",
        isPublished: false,
        teacher: "",
    });
    const [userPagination, setUserPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0,
      });
      
    const [selectedVideos, setSelectedVideos] = useState([]);
    const titleColRef = useRef(null);

    const [videoPagination, setVideoPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0,
    });
    // NEW state for storing the selected image file
    const [selectedImage, setSelectedImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [videos, setVideos] = useState([]);
    
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [allVideos, setAllVideos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [searchFilters, setSearchFilters] = useState({
        name: "",
        title: "",
    });
    const [UserSearchFilters, setUserSearchFilters] = useState({
            username: "",
            personalId: "",
            lastname: "",
            firstname: "",
            phoneNumber: ""
        });
    // Search terms
    const [userSearchTerm, setUserSearchTerm] = useState("");
    const [videoSearchTerm, setVideoSearchTerm] = useState("");
    const [tagInput, setTagInput] = useState("");
    // useEffect(() => {
    //     if (!loading && titleColRef.current) {
    //         titleColRef.current.scrollIntoView({ behavior: "smooth", inline: "center" });
    //     }
    // }, [loading]);
    const onVideoSelectionChange = (newSelectedKeys, selectedRows) => {
    setSelectedVideos((prevSelected) => {
        const updated = new Set(prevSelected);

        // Add newly selected keys
        newSelectedKeys.forEach(key => updated.add(key));

        // Remove deselected ones from current page
        allVideos.forEach(video => {
            if (!newSelectedKeys.includes(video.id)) {
                updated.delete(video.id);
            }
        });

        const finalKeys = Array.from(updated);

        // Preserve or assign order to selected videos
        const newVideoOrder = finalKeys.map((id, index) => ({
            videoId: id,
            order: index + 1
        }));

        setFormData((prev) => ({
            ...prev,
            videos: newVideoOrder
        }));

        return finalKeys;
    });
};


      const handleSearchChange = (e, columnName) => {


        let value = e.target.value;

        const newFilters = {
            ...searchFilters,
            [columnName]: value
        };


        setSearchFilters(newFilters);



        const filteredData = videos.filter(video => {
            return (
                (!newFilters.name || video.name.toLowerCase().includes(newFilters.name.toLowerCase())) &&
                (!newFilters.title || video.title.toLowerCase().includes(newFilters.title.toLowerCase()))
            );
        });

        setAllVideos(filteredData);

    };
    const handleUserSearchChange = (e, columnName) => {

        
        let value = e.target.value;

        const newFilters = {
            ...UserSearchFilters,
            [columnName]: value
        };


        setUserSearchFilters(newFilters);



        const filteredData = users.filter(user => {
            return (
                (!newFilters.username || user.username.toLowerCase().includes(newFilters.username.toLowerCase())) &&
                (!newFilters.personalId || user.personalId.toLowerCase().includes(newFilters.personalId.toLowerCase())) &&
                (!newFilters.lastname || user.lastname.toLowerCase().includes(newFilters.lastname.toLowerCase())) &&
                (!newFilters.firstname || user.firstname.toLowerCase().includes(newFilters.firstname.toLowerCase())) &&
                (!newFilters.phoneNumber || user.phoneNumber.toLowerCase().includes(newFilters.phoneNumber.toLowerCase()))
            );
        });

        setAllUsers(filteredData);
};

    const userSearch = async () => {
        try {
            setUserLoading(true);

            // Build the dynamic filter string
            let dynamicFilter;  // Always include role=0

            if (UserSearchFilters.username) {
                dynamicFilter = `username=*${UserSearchFilters.username}/i`;
            }

            if (UserSearchFilters.personalId) {
                dynamicFilter = `personalId=*${UserSearchFilters.personalId}/i`;
            }
            if (UserSearchFilters.lastname) {
                dynamicFilter = `lastname=*${UserSearchFilters.lastname}/i`;
            }
            if (UserSearchFilters.firstname) {
                dynamicFilter = `firstname=*${UserSearchFilters.firstname}/i`;
            }
            if (UserSearchFilters.phoneNumber) {
                dynamicFilter = `phoneNumber=*${UserSearchFilters.phoneNumber}/i`;
            }
            console.log(UserSearchFilters)
            // Send request with the dynamically constructed filter string
            const response = await axios.get(
                `${config.apiBaseUrl}/api/Users/GetUsersList`,
                {
                    params: {
                        page: 1,
                        pageSize: 10,
                        filter: dynamicFilter,  // Pass the dynamic filter
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            setUsers(prev => {
                const newUsers = response.data.users;
              
                // Avoid duplicates by checking if userID is already present
                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));
              
                return Array.from(userMap.values());
              });
            setAllUsers(prev => {
                const newUsers = response.data.users;
              
                // Avoid duplicates by checking if userID is already present
                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));
              
                return Array.from(userMap.values());
              });
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setUserLoading(false);
            
        }
    }

    const fetchUsersWithFilters = async (uname = "", page = 1, pageSize = 5) => {
        try {
          setUserLoading(true);
          
          const response = await axios.get(
            `${config.apiBaseUrl}/api/Users/GetUsersList`,
            {
              params: {
                page,
                pageSize,
              },
              headers: {
                "HeaderKey": config.HeaderKey,
              },
              withCredentials: true,
            }
          );
          setAllUsers(prev => {
            const newUsers = response.data.users;
            // Avoid duplicates by checking if userID is already present
            const userMap = new Map(prev.map(u => [u.userID, u]));
            newUsers.forEach(user => userMap.set(user.userID, user));
          
            return Array.from(userMap.values());
          });

          setUsers(prev => {
            const newUsers = response.data.users;
          
            // Avoid duplicates by checking if userID is already present
            const userMap = new Map(prev.map(u => [u.userID, u]));
            newUsers.forEach(user => userMap.set(user.userID, user));
          
            return Array.from(userMap.values());
          });
          setUserPagination(prev => ({
            ...prev,
            current: page,
            pageSize,
            total: response.data.totalCount,
          }));
        } catch (error) {
          toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
          if (error.response?.status === 401) {
            navigate("/");
          }
        } finally {
          setUserLoading(false);
        }
      };
      
    const navigate = useNavigate();


   

    // ------------------ Fetch users and videos ------------------ //
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const page = 1;
            const pageSize = 5;
            try {
                const usersResponse = await axios.get(
                    `${config.apiBaseUrl}/api/users/getuserslist?`,
                    {
                        params: {
                            page,
                            pageSize,
                        },
                        headers: {
                            HeaderKey:
                                config.HeaderKey,
                        },
                        withCredentials: true,
                    }
                );

                setUserPagination({
                    page:page,
                    pageSize:pageSize,
                    total: usersResponse.data.totalCount, // pass total here
                });
                const videoPage = 1;
                const videoPageSize = 50000;
                const videosResponse = await axios.get(`${config.apiBaseUrl}/api/video/GetFilteredList`, {
                    params: {
                        page:videoPage,
                        pageSize:videoPageSize,
                        orderBy:"uploadedAt desc",
                        filter: "completed=true"
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true
                });
                setUsers(usersResponse.data.users);
                setAllUsers(usersResponse.data.users);
                setAllVideos(videosResponse.data.videos);
                setVideos(videosResponse.data.videos);
            } catch (error) {
                
                toast.error("خطا در دریافت اطلاعات کاربران یا ویدیوها!", {
                    autoClose: 3000,
                });
                if (error.response && error.response.status === 401) {
                    navigate("/");
                }
            } finally {
                setLoading(false);
                setUserLoading(false);
            }
        };

        fetchData();
    }, [navigate]);

    // ------------------ Handle input changes ------------------ //
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // ------------------ Handle file selection ------------------ //
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
    };

    // ------------------ Toggle selection (Users & Videos) ------------------ //
    const toggleSelection = (id, type) => {
        setFormData((prev) => {
            if (type === "videos") {
                const exists = prev.videos.some(v => v.videoId === id);
                let updatedVideos;
                if (exists) {
                    updatedVideos = prev.videos.filter(v => v.videoId !== id);
                } else {
                    updatedVideos = [...prev.videos, { videoId: id, order: prev.videos.length + 1 }];
                }
                return { ...prev, videos: updatedVideos };
            } else {
                const updatedList = prev[type].includes(id)
                    ? prev[type].filter((item) => item !== id)
                    : [...prev[type], id];

                return { ...prev, [type]: updatedList };
            }
        });
    };


    // ------------------ Submit form ------------------ //
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Split comma-separated tags into array


        // Prepare FormData for multipart/form-data
        const formDataToSend = new FormData();

        // Append simple fields (server is case-insensitive by default, but let's match exactly if possible)
        formDataToSend.append("title", formData.title);
        formDataToSend.append("shortDescription", formData.shortDescription);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("price", formData.price);
        formDataToSend.append("pictureUrl", formData.pictureUrl || "");
        formDataToSend.append("isPublished", formData.isPublished);
        formDataToSend.append("teacher", formData.teacher);


        formData.tags.forEach(tag => {
            formDataToSend.append("tags", tag); // Append each tag individually
        });

        // Append enrolledUserIds
        formData.enrolledUserIds.forEach((userId) => {
            formDataToSend.append("enrolledUserIds", userId);
        });

        // Append videos
        formData.videos.forEach((videoObj, index) => {
            formDataToSend.append(`Videos[${index}].VideoId`, videoObj.videoId);
            formDataToSend.append(`Videos[${index}].Order`, videoObj.order);
        });

        formData.videos
            .sort((a, b) => a.order - b.order)
            .forEach((videoObj, index) => {
                formDataToSend.append(`Videos[${index}].VideoId`, videoObj.videoId);
                formDataToSend.append(`Videos[${index}].Order`, videoObj.order);
            });

        // Finally, append image file if selected
        if (selectedImage) {
            formDataToSend.append("image", selectedImage);
        }

        try {
            const response = await axios.post(
                `${config.apiBaseUrl}/api/Course/AddNewCourse`,
                formDataToSend,
                {
                    headers: {
                        
                        HeaderKey:
                            config.HeaderKey
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200) {
                toast.success("دوره با موفقیت ساخته شد!", { autoClose: 3000 });
                setFormData({
                    title: "",
                    shortDescription: "",
                    description: "",
                    price: 0,
                    tags: [],
                    enrolledUserIds: [],
                    videos: [],
                    pictureUrl: "",
                    isPublished: false,
                    teacher: "",
                });
                setSelectedImage(null);
                await sleep(1000)
                navigate("/dashboard/courses");
            } else {
                toast.error("خطا در ساخت دوره!", { autoClose: 3000 });
            }
        } catch (error) {
            if (error.response && error.response.status === 408) {
                toast.error("انتخاب تصویر دوره الزامیست", { autoClose: 3000 });
            } else {
                toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
                if (error.response && error.response.status === 401) {
                    navigate("/");
                }
            }
        } finally {
            setIsLoading(false);
        }
    };

    const sleep = ms => new Promise(r => setTimeout(r, ms));

    // ------------------ Filtering Logic ------------------ //
    const filteredUsers = allUsers.filter((u) =>
        (u.firstname + " " + u.lastname)
            .toLowerCase()
            .includes(userSearchTerm.toLowerCase())
    );

    const filteredVideos = allVideos.filter((v) =>
        v.name.toLowerCase().includes(videoSearchTerm.toLowerCase())
    );


    // Handle Tag Input
    const handleTagChange = (e) => {
        const value = e.target.value;
        const separators = [",", "،"]; // Both English and Persian comma

        // Check if input contains a separator
        if (separators.some(sep => value.includes(sep))) {
            const newTag = value.replace(/[,،]/g, "").trim(); // Remove any separators
            if (newTag && !formData.tags.includes(newTag)) {
                setFormData((prev) => ({
                    ...prev,
                    tags: [...prev.tags, newTag], // Add new tag
                }));
            }
            setTagInput(""); // Clear input after adding tag
        } else {
            setTagInput(value);
        }
    };

    // Remove a tag when clicked
    const removeTag = (index) => {
        setFormData((prev) => ({
            ...prev,
            tags: prev.tags.filter((_, i) => i !== index),
        }));
    };
    const handleOrderChange = (videoId, newOrder) => {
        setFormData((prev) => ({
            ...prev,
            videos: prev.videos.map((v) =>
                v.videoId === videoId ? { ...v, order: newOrder } : v
            ),
        }));
    };


    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6 rtl font-custom">
            <div className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center mb-6">اضافه کردن دوره جدید</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Title & Short Description */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input
                            type="text"
                            name="shortDescription"
                            placeholder="توضیح کوتاه"
                            value={formData.shortDescription}
                            onChange={handleChange}
                            className="p-3 border rounded-md text-right"
                            required
                            dir="rtl"
                        />
                        <input
                            type="text"
                            name="title"
                            placeholder="عنوان دوره"
                            value={formData.title}
                            onChange={handleChange}
                            className="p-3 border rounded-md text-right"
                            required
                            dir="rtl"
                        />
                    </div>

                    {/* Description */}
                    <textarea
                        name="description"
                        placeholder="توضیح کامل دوره"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4}
                        className="w-full p-3 border rounded-md text-right"
                        required
                        dir="rtl"
                    />

                    {/* Price & Teacher */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input
                            type="number"
                            name="price"
                            placeholder="قیمت دوره (تومان)"
                            value={formData.price}
                            onChange={handleChange}
                            className="w-full p-3 border rounded-md"
                            required
                        />
                        <input
                            type="text"
                            name="teacher"
                            placeholder="مدرس دوره"
                            value={formData.teacher}
                            onChange={handleChange}
                            className="p-3 border rounded-md text-right"
                            required
                            dir="rtl"
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-semibold text-gray-700">تصویر دوره:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="p-2 border rounded-md"
                            placeholder="تصویر دوره الزامیست"
                        />
                        {selectedImage && (
                            <p className="mt-1 text-sm text-green-600">
                                {selectedImage.name} : تصویر انتخاب شده
                            </p>
                        )}
                    </div>

                    <div>
                        <div className="p-3 border rounded-md w-full text-right">
                            <div className="flex flex-wrap gap-2 mb-2">
                                {formData.tags.map((tag, index) => (
                                    <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full flex items-center">
                                        {tag}
                                        <button
                                            type="button"
                                            onClick={() => removeTag(index)}
                                            className="ml-2 text-red-500 font-bold hover:text-red-700"
                                        >
                                            ✖
                                        </button>
                                    </span>
                                ))}
                            </div>

                            <input
                                type="text"
                                name="tags"
                                placeholder="تگ‌ها را با کاما یا ویرگول جدا کنید"
                                value={tagInput}
                                onChange={handleTagChange}
                                className="p-2 border rounded-md w-full text-right focus:outline-none"
                                dir="rtl"
                            />
                        </div>
                    </div>

                    <div className="grid text-right rtl grid-cols-1  gap-4">
                        <div className="flex items-center my-8">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <h2 className="mx-4 text-xl font-bold text-gray-400 whitespace-nowrap font-custom">
                            انتخاب کاربران دوره
                            </h2>
                            <div className="flex-grow border-t border-gray-300"></div>
                        </div>
                        <div className="mb-3 flex justify-start">
                            <SelectUsersExcelButton
                                onSelected={(newUsers) => {
                                    setAllUsers(prev => {
                                        const map = new Map(prev.map(u => [u.userID, u]));
                                        newUsers.forEach(u => map.set(u.userID, u));
                                        return Array.from(map.values());
                                    });
                                    setUsers(prev => {
                                        const map = new Map(prev.map(u => [u.userID, u]));
                                        newUsers.forEach(u => map.set(u.userID, u));
                                        return Array.from(map.values());
                                    });
                                    setFormData(prev => {
                                        const map = new Map(prev.enrolledUserIds.map(id => [id, id]));
                                        newUsers.forEach(u => map.set(u.userID, u.userID));
                                        return { ...prev, enrolledUserIds: Array.from(map.values()) };
                                    });
                                }}
                            />
                        </div>

                        <Table
                            rowSelection={{
                                selectedRowKeys: formData.enrolledUserIds,
                                onChange: (newSelectedKeys) => {
                                  setFormData(prev => {
                                    const updated = new Set(prev.enrolledUserIds);
                              
                                    // Add any new selected keys
                                    newSelectedKeys.forEach(id => updated.add(id));
                              
                                    // Remove any keys that were visible and deselected
                                    allUsers.forEach(user => {
                                      if (!newSelectedKeys.includes(user.userID)) {
                                        updated.delete(user.userID);
                                      }
                                    });
                              
                                    return {
                                      ...prev,
                                      enrolledUserIds: Array.from(updated),
                                    };
                                  });
                                },
                                fixed: 'left',
                              }}                              
                            columns={[
                                {
                                    title: 'نام خانوادگی',
                                    dataIndex: 'lastname',
                                    key: 'lastname',
                                    align: 'right',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی نام خانوادگی"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            lastname: "",
                                                        }));
                                                    }}                    
                                                    value={UserSearchFilters.lastname}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "lastname");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        // Server-side search when button is clicked
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'نام کاربری',
                                    dataIndex: 'username',
                                    key: 'username',
                                    align: 'right',
                                    className: 'font-custom'
                                    ,filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی نام کاربری"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            username: "",
                                                        }));
                                                    }}                    
                                                    value={UserSearchFilters.username}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "username");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        // Server-side search when button is clicked
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'کد ملی',
                                    dataIndex: 'personalId',
                                    key: 'personalId',
                                    align: 'center',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی کدملی"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            personalId: "",
                                                        }));
                                                    }}                    
                                                    value={UserSearchFilters.personalId}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "personalId");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        // Server-side search when button is clicked
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'شماره تلفن',
                                    dataIndex: 'phoneNumber',
                                    key: 'phoneNumber',
                                    align: 'center',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی شماره تلفن"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            personalId: "",
                                                        }));
                                                    }}                    
                                                    value={UserSearchFilters.phoneNumber}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "phoneNumber");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        // Server-side search when button is clicked
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                            ]}
                            dataSource={[
                                // ✅ Selected users in order of formData.enrolledUserIds
                                ...formData.enrolledUserIds
                                    .map(id => allUsers.find(user => user.userID === id))
                                    .filter(Boolean),

                                // ✅ Non-selected users
                                ...allUsers.filter(user => !formData.enrolledUserIds.includes(user.userID))
                            ]}
                            scroll={{ x: 700 }}
                            rowKey="userID"
                            pagination={{
                                current: userPagination.current,
                                pageSize: userPagination.pageSize,
                                total: userPagination.total,
                                onChange: (page, pageSize) => {
                                    setUserPagination(prev => ({ ...prev, current: page, pageSize }));
                                    fetchUsersWithFilters(userSearchTerm, page, pageSize);
                                }
                            }}
                            loading={userLoading}
                        />

                        <div className="flex items-center my-8">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <h2 className="mx-4 text-xl font-bold text-gray-400 whitespace-nowrap font-custom">
                                انتخاب ویدئوهای دوره
                            </h2>
                            <div className="flex-grow border-t border-gray-300"></div>
                        </div>
                        <Table
                            rowSelection={{
                                selectedRowKeys: selectedVideos, // Use selectedVideos state
                                onChange: onVideoSelectionChange, // Update selection on change
                                fixed: "left",
                            }}
                            columns={[
                                {
                                    title: 'نام فایل',
                                    dataIndex: 'name',
                                    key: 'name',
                                    width: 200,
                                    align: 'right',
                                    className:'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }}>
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    className="font-custom"
                                                    placeholder="جستجوی نام فایل"
                                                    allowClear
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            name: "",
                                                        }));
                                                    }}
                                                    value={searchFilters.name}
                                                    onChange={(e) => {
                                                        handleSearchChange(e, "name");
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'عنوان',
                                    dataIndex: 'title',
                                    width: 250,
                                    key: 'title',
                                    className: 'font-custom',
                                    align: 'right',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    className="font-custom"
                                                    placeholder="جستجوی عنوان ویدئو"
                                                    allowClear
                                                    onClear={() => {
                                                        // Reset the search filter and re-fetch data
                                                        setSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            title: "",
                                                        }));
                                                    }}
                                                    value={searchFilters.title}
                                                    onChange={(e) => {
                                                        handleSearchChange(e, "title");
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                    
                                },
                                {
                                    title: 'اولویت',
                                    className: 'font-custom',
                                    width: 100,
                                    key: 'order',
                                    render: (_, record) => {
                                        const current = formData.videos.find(v => v.videoId === record.id);
                                        return current ? (
                                            <div ref={titleColRef}>
                                                <input
                                                    type="number"
                                                    value={current.order}
                                                    ref={titleColRef}
                                                    onChange={(e) => handleOrderChange(record.id, parseInt(e.target.value))}
                                                    className="w-16 p-1 border rounded-md text-center"
                                                    min="1"
                                                />
                                            </div>

                                        ) : <div ref={titleColRef}></div>;
                                    },
                                }
                            ]}
                            dataSource={[
                                // ✅ Selected videos, sorted by order
                                ...formData.videos
                                    .map(v => allVideos.find(av => av.id === v.videoId))
                                    .filter(Boolean)
                                    .sort((a, b) => {
                                        const orderA = formData.videos.find(v => v.videoId === a.id)?.order ?? 0;
                                        const orderB = formData.videos.find(v => v.videoId === b.id)?.order ?? 0;
                                        return orderA - orderB;
                                    }),

                                // ✅ Non-selected videos
                                ...filteredVideos.filter(v => !formData.videos.some(sel => sel.videoId === v.id))
                            ]}

                            scroll={{ x: 500 }}
                            rowKey="id"
                            pagination={{
                                current: videoPagination.current,
                                pageSize: videoPagination.pageSize,
                                total: videoPagination.total,
                                onChange: (page, pageSize) => {
                                    setVideoPagination((prev) => ({ ...prev, current: page, pageSize }));
                                    // fetchVideos(page, pageSize);
                                },
                            }}
                            loading={loading}
                        />
                    </div>

                    {/* Published Switch */}
                    <div className="flex items-center justify-end mb-2 gap-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                name="isPublished"
                                checked={formData.isPublished}
                                onChange={handleChange}
                                className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-green-500 peer-checked:bg-green-600 transition-colors peer-checked:after:translate-x-full after:content-[''] after:absolute after:left-1 after:top-1 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
                        </label>
                        <label className="text-gray-700">منتشر شده</label>
                    </div>
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full flex justify-center items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isLoading ? <FaSpinner className="animate-spin" /> : "افزودن دوره"}
                    </button>
                </form>
            </div>

            {/* Toast Notifications */}
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                theme="dark"
                transition={Bounce}
                className="rtl font-custom"
            />
        </div>
    );
};

export default AddCourse;
